<template>
  <!--内容-->
  <div style="background-color: #fff">
    <Row justify="center" type="flex">
      <Col span="24">
        <img
          style="width: 100%; height: 500px"
          src="../../../static/img/banner/product.png"
          alt="#"
        />
      </Col>
    </Row>
    <Row justify="center" type="flex" style="padding-top: 30px">
      <Col :xs="18" :sm="18" :md="18" :lg="5" :xl="5" :offset="1">
        <div class="showPhoto">
          <vue-photo-zoom-pro :url="photoUrl1"></vue-photo-zoom-pro>
        </div>
      </Col>
      <br />
      <Col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="{ span: 7, offset: 1 }"
        :xl="{ span: 7, offset: 1 }"
        style="margin-top: 20px"
      >
        <div
          style="line-height: 40px; font-family: 宋体, serif; font-weight: bold"
        >
          <span style="font-size: 19px">{{ this.ref }}</span>
        </div>
        <Form
          :model="formValidate"
          ref="formValidate"
          :rules="rule"
          :label-width="100"
        >
          <FormItem label="价格:" prop="money">
            <span style="color: red; font-size: 18px">{{ this.money }}</span>
          </FormItem>
          <FormItem label="选择城市:" prop="city">
            <div style="width: 64%">
              <Cascader
                filterable
                :data="formValidate.city"
                size="large"
                @on-change="getAdress"
                placeholder="请选择城市\可搜索"
              ></Cascader>
            </div>
          </FormItem>
          <FormItem label="详细地址:" prop="InputAddress">
            <label>
              <Input
                v-model="formValidate.InputAddress"
                maxlength="60"
                style="width: 70%"
                show-word-limit
                :rows="2"
                type="textarea"
                placeholder="请输入详细地址"
              ></Input>
            </label>
          </FormItem>
          <FormItem label="颜色分类:">
            <div
              style="
                display: inline-block;
                padding: 0 20px 0 10px;
                cursor: pointer;
              "
              v-for="(item, index) in classify"
              :key="index"
            >
              <div
                :id="'getCol' + index"
                @click="getColor(index, classify)"
                style="
                  background: white;
                  padding: 0 6px 0 6px;
                  margin: 4px 0 4px 0;
                "
              >
                <span>{{ item.type }}</span>
              </div>
            </div>
          </FormItem>
          <FormItem label="数量:" prop="nums">
            <InputNumber v-model="formValidate.nums" :min="1"></InputNumber>
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              class="btn-submit"
              @click="submit('formValidate')"
              >立即购买</Button
            >
          </FormItem>
        </Form>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "GoBuy",
  data() {
    return {
      showImg: false,
      money: "",
      ref: "",
      photoUrl1: "",
      belong: "",
      title: "",
      path: "",
      classify: [],
      /*价钱*/
      price: {
        type: Number,
      },
      /**/
      actAnchor: false,
      Address: [],
      formValidate: {
        city: [],
        InputAddress: "",
        nums: 1,
      },
      rule: {
        InputAddress: [
          {
            required: true,
            type: "string",
            message: "详细地址不能为空",
            trigger: "blur",
          },
          { type: "string", min: 6, message: "最少8个字符" },
        ],
        city: [
          {
            type: "array",
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    this.$axios.get("/static/json/provinces.json").then((res) => {
      this.formValidate.city = res.data.data;
    });
  },
  mounted() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    getData() {
      this.money = sessionStorage.getItem("money");
      this.belong = sessionStorage.getItem("belong");
      this.title = sessionStorage.getItem("title");
      this.path = sessionStorage.getItem("path");
      this.ref = sessionStorage.getItem("ref");
      this.photoUrl1 = sessionStorage.getItem("photoUrl1");
      this.classify = JSON.parse(sessionStorage.getItem("classify"));
    },
    /*获取颜色*/
    getColor(x, nums) {
      console.log(x, nums);
      this.photoUrl1 = nums[x].img;
      this.money = nums[x].money;
      this.price = parseInt(this.money.substr(1));
      var getCol = $("#getCol");
      var arrs = [];
      for (let i = 0; i < nums.length; i++) {
        arrs.push(i);
      }

      function f(x) {
        if (arrs.length > 1) {
          let arr = arrs.filter((res) => res !== x);
          for (let j = 0; j < arr.length; j++) {
            getCol = $("#getCol" + arr[j]).removeClass("img-hover");
          }
          getCol = $("#getCol" + x).addClass("img-hover");
        } else {
          getCol = $("#getCol" + x).addClass("img-hover");
        }
      }
      f(x);
    },
    /*提交*/
    submit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.price *= this.formValidate.nums;
          console.log(
            this.formValidate.InputAddress +
              "==" +
              this.Address +
              "==" +
              this.formValidate.nums +
              "，价钱：" +
              this.price
          );
          this.$Message.success("提交成功");
        } else {
          this.$Message.error("提交失败");
        }
      });
    },
    /*获取三级联动事件*/
    getAdress(value, selectedData) {
      console.log(value, selectedData);
      this.Address = value;
    },
  },
};
</script>

<style scoped>
.BuyGoMenu {
  display: flex;
  width: 100%;
  background: linear-gradient(to bottom, #ffffff, #dddddd);
  margin-top: 15px;
}

/*------------展示图片--------------*/
.showPhoto {
  border: 1px solid #e8e8e8;
  width: 400px;
  height: 400px;
  text-align: center;
}

/*---------------------------------*/

/*---------------图片--------------*/
.img-hover {
  border: 2px solid red;
  background: white;
  padding: 0 6px 0 6px;
  border-radius: 5px;
}

/*--------------------------------*/
</style>



// WEBPACK FOOTER //
// src/components/Buy/BuyGo.vue